<template>
  <v-card>
    <v-card-title>
      <!-- eslint-disable -->
      <v-text-field
        v-show="showSearch"
        v-model="search"
        append-icon="mdi-magnify"
        :label="searchLabel + (effectiveDisableIntellySearch ? ' (presione Enter para Ejecutar Búsqueda...)' : '')"
        @keydown.enter.prevent="readDataFromAPI(true)"
      ></v-text-field>
      <!-- eslint-enable -->
    </v-card-title>
    <div class="table-footer-prepend d-flex pl-2 align-center">
      <v-tooltip top>
        <template v-slot:activator="{ activationEvents }">
          <v-btn
            icon
            outlined
            color="primary"
            class="mr-3"
            v-on="activationEvents"
            @click="$emit('add')"
            v-show="canAdd === true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Agregar</span>
      </v-tooltip>
    </div>
    <v-data-table
      dense
      v-bind:page="page"
      :pageCount="this.pageCount"
      :loading="loading"
      :headers="headers"
      :items="items"
      :itemsPerPage="itemsPerPage"
      :serverItemsLength="serverItemsLength"
      :options.sync="options"
      :search.sync="search"
      @click:row="onClickRow"
      :show-select="this.multipleSelection"
      v-model="selected_items"
    >
      <template v-slot:top="{ options, updateOptions }">
        <div class="table-footer-append d-flex align-center justify-end">
          <span class="mr-2">{{ paginationSummary }}</span>
          <v-btn
            icon
            small
            class="mr-1"
            :disabled="!canGoPrevious"
            @click="goToFirstPage"
          >
            <v-icon>mdi-page-first</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            class="mr-1"
            :disabled="!canGoPrevious"
            @click="updateOptions(Object.assign({}, options, { page: page - 1 }))"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            class="mr-1"
            :disabled="!canGoNext"
            @click="updateOptions(Object.assign({}, options, { page: page + 1 }))"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            class="ml-0"
            :disabled="!canGoNext"
            @click="goToLastPage"
          >
            <v-icon>mdi-page-last</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          v-show="canEdit"
          small
          class="mr-2"
          @click.stop="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-show="canDelete"
          small
          class="mr-2"
          @click.stop="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
        <v-icon
          v-show="canViewDocument"
          small
          class="mr-2"
          @click.stop="viewDocumentItem(item)"
        >
          mdi-eye-outline
        </v-icon>
        <v-icon
          v-show="messageStatus"
          small
          class="mr-2"
          enabled="false"
          :color="
            item.readed ? 'green' : item.avoid_navigation ? 'red' : 'yellow'
          "
        >
          {{
            item.readed
              ? "mdi-email-open-outline"
              : item.avoid_navigation
              ? "mdi-email-lock-outline"
              : "mdi-email-outline"
          }}
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "PaginatedSearchTable",
  props: {
    endpoint: {
      type: String,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchLabel: {
      type: String,
      default: "Buscar"
    },
    ordering: {
      type: String,
      default: null
    },
    filterString: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    canViewDocument: {
      type: Boolean,
      default: false
    },
    searchOnURL: {
      type: Boolean,
      default: false
    },
    initialItemsPerPage: {
      type: Number,
      default: 100
    },
    noIntellySearch: {
      type: Boolean,
      default: false
    },
    messageStatus: {
      type: Boolean,
      default: false
    },
    multipleSelection: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  data() {
    return {
      search: "",
      loading: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: this.initialItemsPerPage,
      options: {},
      items: [],
      selected_items: [],
      disableIntellySearch: this.$bRoot.getUserParam("disableIntellySearch"),
      hasLoadedData: false
    };
  },

  computed: {
    effectiveDisableIntellySearch() {
      return this.noIntellySearch || this.disableIntellySearch;
    },
    canGoPrevious() {
      return this.page > 1;
    },
    canGoNext() {
      return this.page < this.pageCount;
    },
    paginationSummary() {
      if (this.serverItemsLength === 0) {
        return "0-0 of 0";
      }

      const fromItem = (this.page - 1) * this.itemsPerPage + 1;
      const toItem = Math.min(
        this.page * this.itemsPerPage,
        this.serverItemsLength
      );
      return fromItem + "-" + toItem + " of " + this.serverItemsLength;
    }
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler() {
        if (this.noIntellySearch && !this.hasLoadedData) {
          return;
        }
        this.readDataFromAPI(false);
      }
    },
    /* en función de disable auto search */
    search: {
      handler() {
        if (!this.effectiveDisableIntellySearch) {
          this.readDataFromAPI(true);
        }
      }
    },
    selected_items: {
      handler() {
        this.selectionChange();
      }
    },
    deep: true
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset) {
      try {
        /*eslint-disable */
        const {
          page = 1,
          itemsPerPage = this.itemsPerPage
        } = this.options;
        let pageNumber = reset ? 1 : page;
        this.loading = true;
        this.itemsPerPage = itemsPerPage;
        let search = null;
        let endpoint = this.endpoint;
        if (this.searchOnURL) {
          endpoint =
            endpoint +
            "/" +
            (this.search ? this.search.replace(/[^a-zA-Z0-9]+/g, "_") : "_");
        } else {
          search = this.search.replace(/[^a-zA-Z0-9\s]+/g, '_');
        }
        if (this.endpoint === "/data/territories_hierarchy" && (search ? search : "").split(",").length > 1) {
          search.split(",").forEach((element, index) => {
            if (index <= 3) {
              filterstring = (filterstring ? filterstring + "&" : "") + "level" + (3 - index).toString() + "_description__icontains=" + element;
            }
          });
          search = null;
        } else if (this.endpoint.startsWith("/data/sale_commissions/claimable/")) {
          endpoint = endpoint +
            "/" +
            (search == "" ? "*" : search);
          search = null;
        }
        let res = await this.$bRoot.search(
          endpoint,
          search,
          this.ordering,
          this.filterString,
          pageNumber,
          itemsPerPage
        );
        if (this.$bRoot.errors) {
          throw "Error recuperando datos";
        }
        if (res) {
          this.items = res.data.results;
          if (this.multipleSelection) {
            this.items.forEach( item => {
                item.selected = false;
            })
          }
          this.serverItemsLength = res.data.count;
          this.page = pageNumber;
          this.pageCount = Math.ceil(res.data.count / this.itemsPerPage);
          this.hasLoadedData = true;
        }
      /*eslint-ebable */
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
        if (this.$bRoot.errors) {
          this.$emit("error");
        }
      }
    },
    onClickRow(item) {
      if (this.multipleSelection===false) {
        this.$emit("itemSelected", item);
      }
    },
    goToFirstPage() {
      this.updatePage(1);
    },
    goToLastPage() {
      this.updatePage(this.pageCount);
    },
    updatePage(page) {
      if (page < 1 || page > this.pageCount || page === this.page) {
        return;
      }

      this.options = {
        ...this.options,
        page
      };
    },
    editItem(item) {
      this.$emit("editItem", item);
    },
    deleteItem(item) {
      this.$emit("deleteItem", item);
    },
    viewDocumentItem(item) {
      this.$emit("viewDocumentItem", item);
    },
    selectionChange(event) {
      this.$emit("selectionChange", this.selected_items)
    },
    addNew() {
      this.$emit("add");
    },
  },

  //this will trigger in the onReady State
  mounted() {
    this.selected_items = this.selectedItems;
    if (!this.noIntellySearch) {
      this.readDataFromAPI();
    } else {
      this.loading = false;
    }
  }
};
</script>

<style>
.v-data-footer__select {
  display: none !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.table-footer-append {
  min-height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
</style>
